import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/home.vue'
//导航
import Index from '../page/Index.vue'
import Outsourcing from '../page/Outsourcing.vue'
import Makeliving from '../page/Makeliving.vue'
import Recruiting from '../page/Recruiting.vue'
import Seekinsurance from '../page/Seekinsurance.vue'
import Download from '../page/Download.vue'

// // 主组件
import myHeader from '../components/myHeader.vue'
// import myMain from '../components/myMain.vue'
import myFooter from '../components/myFooter.vue'
Vue.component('my-header', myHeader)
Vue.component('my-footer', myFooter)

//1 注入插件
Vue.use(VueRouter)

//解决路由地址重复的报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}


//2 定义路由
const routes = [{
		path: '/',
		redirect: '/home'
	},
	{
		path: '/home',
		name: 'home',
		component: Home,
		redirect: '/index',
		children: [{
				path: '/index',
				name: 'index',
				component: Index
			},
			{
				path: '/Outsourcing',
				name: 'Outsourcing',
				component: Outsourcing
			},
			{
				path: '/Makeliving',
				name: 'Makeliving',
				component: Makeliving
			},
			{
				path: '/Recruiting',
				name: 'Recruiting',
				component: Recruiting
			},
			{
				path: '/Seekinsurance',
				name: 'Seekinsurance',
				component: Seekinsurance
			},
			{
				path: '/Download',
				name: 'Download',
				component: Download
			}
		]
	}
]

//3 创建router实例
const router = new VueRouter({
	// mode: 'history',//HTML5 History 模式
	routes,
	linkActiveClass: 'active' //修改类名称
})

// 4 导出router实例
export default router



// WEBPACK FOOTER //
// ./src/router/index.js